import { render, staticRenderFns } from "./chatGroupPicture.vue?vue&type=template&id=136941cc&scoped=true"
import script from "./chatGroupPicture.vue?vue&type=script&lang=js"
export * from "./chatGroupPicture.vue?vue&type=script&lang=js"
import style0 from "./chatGroupPicture.vue?vue&type=style&index=0&id=136941cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136941cc",
  null
  
)

export default component.exports